import {Header as HeaderComponent, Row} from "components";
import {AssuredWorkloadOutlined} from "@mui/icons-material";

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  return (
    <Row width="100%" marginBottom={10}>
      <HeaderComponent icon={AssuredWorkloadOutlined} children="Créditos" />
    </Row>
  );
};
